export enum TotpStatus {
  NOT_ENROLLED = 'NOT_ENROLLED',
  ENROLLED = 'ENROLLED',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export const TOTP_STATUS_VALUES = {
  NOT_ENROLLED: 'NOT_ENROLLED',
  ENROLLED: 'ENROLLED',
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
} as const;

export type TotpStatusType = (typeof TOTP_STATUS_VALUES)[keyof typeof TOTP_STATUS_VALUES];
